let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { AVATAR_BACKGROUND_COLOR_THEME_KEY } from '../../Constants';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const EditOverlay = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  inset: 0;
  cursor: pointer;
  transition: opacity 300ms ease;
  opacity: 0;

  &:hover {
    opacity: 1;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${0};
    opacity: 0.85;
  }
`), ({
  theme
}) => theme.color[AVATAR_BACKGROUND_COLOR_THEME_KEY]);
export const AvatarEditOverlay = () => {
  return /*#__PURE__*/_jsx(EditOverlay, {
    "data-test-id": "AvatarDisplay-editOverlay",
    children: /*#__PURE__*/_jsx(Flex, {
      position: "absolute",
      insetBlockStart: "0",
      insetInlineEnd: "0",
      insetBlockEnd: "0",
      insetInlineStart: "0",
      justifyContent: "center",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(EditIcon, {
        size: "inherit",
        color: "text-core-on-fill-default"
      })
    })
  });
};